module.exports = __webpack_public_path__ + "img/knight4cf_02.51cd9479.jpg";